import { useSmsQuota } from "@/hooks/useSmsQuota";

export const SmsQuotaBadge = () => {
  const { quota, loading } = useSmsQuota();
  if (loading || !quota) return null;
  const used = quota.used_this_cycle;
  const base = quota.base_allowance;
  const rollover = quota.rollover_balance;
  const topup = quota.topup_balance;
  const total = quota.total_remaining;
  const low = total <= 5;
  return (
    <div
      className={`text-[11px] sm:text-xs rounded-md border px-2 py-1 inline-flex items-center gap-2 ${
        low ? "border-destructive/40 text-destructive bg-destructive/5" : "border-border text-muted-foreground bg-muted/40"
      }`}
      title={`Cycle ends ${new Date(quota.cycle_end).toLocaleDateString("en-GB")}`}
    >
      <span className="font-medium">SMS:</span>
      <span>{used} / {base} this cycle</span>
      {rollover > 0 && <span>· +{rollover} rollover</span>}
      {topup > 0 && <span>· +{topup} top-up</span>}
      <span className="font-medium">({total} left)</span>
    </div>
  );
};

export default SmsQuotaBadge;
